// @flow
import React from 'react';

export default ({ className = '', ...props }) => (
  <i className={`${className} fa fa-cutlery`} {...props} />
);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/theme/icons/Cutlery.js